import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useNavigate, useLocation } from 'react-router-dom';

const SupportFab: React.FC = () => {
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Nascondi su pagine dove l'overlay darebbe fastidio
  const hiddenPaths = ['/assistenza'];
  if (hiddenPaths.includes(location.pathname)) return null;

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        setLoading(true);
        const res = await api.get('/messages/conversations');
        if (cancelled) return;
        const total = (res.data || []).reduce((sum: number, c: any) => sum + (c.unread_count || 0), 0);
        setUnread(total);
      } catch {
        // ignore
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    // refresh leggero ogni 60s
    const t = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  const openSupport = async () => {
    try {
      const res = await api.post('/support/chat/start');
      const conversationId = res.data?.conversation_id;
      if (conversationId) {
        navigate(`/messaggi?conversationId=${conversationId}`);
      } else {
        navigate('/assistenza');
      }
    } catch {
      navigate('/assistenza');
    }
  };

  return (
    <button
      onClick={openSupport}
      title="Assistenza"
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        zIndex: 1000,
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: '#2563eb',
        color: '#fff',
        border: 'none',
        boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
        cursor: 'pointer'
      }}
    >
      <span style={{ fontSize: 22 }}>❓</span>
      {unread > 0 && (
        <span style={{
          position: 'absolute',
          top: -4,
          right: -4,
          backgroundColor: '#ef4444',
          color: '#fff',
          borderRadius: '999px',
          padding: '2px 6px',
          fontSize: 12,
          fontWeight: 700
        }}>{unread}</span>
      )}
    </button>
  );
};

export default SupportFab;